module.exports = __webpack_public_path__ + "static/media/36-8.d198f094.mp3";